"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlUser = void 0;
var PlUser;
(function (PlUser) {
    PlUser["PC_WORKER"] = "yqz_pc";
    PlUser["PC_OWNER"] = "pc_owner";
    PlUser["H5_OWNER"] = "h5_owner";
    PlUser["MINI_OWNER"] = "mini_owner";
    PlUser["MINI_YQZ"] = "mini_yqz";
    PlUser["RN_WORKER"] = "rn_worker";
    PlUser["YQZ_ADMIN"] = "yqz_admin";
    PlUser["H5_WORKER"] = "h5_worker";
    PlUser["DECO_ASSIS"] = "decoAssistant";
})(PlUser = exports.PlUser || (exports.PlUser = {}));
//# sourceMappingURL=pl-user.type.js.map